import { Shield, MapPin, Home, Wifi, Award, Users, GraduationCap, Target } from 'lucide-react';

const CHIP_CONFIG = {
  strong_mos_alignment: { label: 'MOS Match', icon: Target, style: 'bg-brand-light text-brand border-brand/20' },
  skills_overlap_high:  { label: 'Skills Match', icon: Shield, style: 'bg-brand-light text-brand border-brand/20' },
  leadership_signal:    { label: 'Leadership', icon: Users, style: 'bg-indigo-50 text-indigo-700 border-indigo-200' },
  certifications_relevant: { label: 'Certifications', icon: Award, style: 'bg-amber-50 text-amber-700 border-amber-200' },
  near_home:            { label: 'Near Home', icon: Home, style: 'bg-sky-50 text-sky-700 border-sky-200' },
  near_base:            { label: 'Near Base', icon: MapPin, style: 'bg-teal-50 text-teal-700 border-teal-200' },
  remote_friendly:      { label: 'Remote', icon: Wifi, style: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  education_relevant:   { label: 'Education', icon: GraduationCap, style: 'bg-violet-50 text-violet-700 border-violet-200' },
};

export function MatchScoreBadge({ score, size = 'md' }) {
  if (score == null) return null;
  const rounded = Math.round(score);
  const color = rounded >= 70 ? 'bg-brand text-white' :
                rounded >= 40 ? 'bg-amber-500 text-white' :
                'bg-slate-400 text-white';
  const sizeClass = size === 'sm' ? 'text-[10px] px-1.5 py-0.5' :
                    size === 'lg' ? 'text-sm px-3 py-1' :
                    'text-xs px-2 py-0.5';
  return (
    <span className={`font-bold rounded-full ${color} ${sizeClass} tabular-nums`} data-testid="match-score-badge">
      {rounded}%
    </span>
  );
}

export function ExplanationChips({ tags = [], reasons = [], max = 4 }) {
  if (!tags?.length && !reasons?.length) return null;

  // Use tags for styled chips if available, fall back to reasons
  const chips = tags.slice(0, max).map((tag) => {
    const config = CHIP_CONFIG[tag];
    if (config) {
      const Icon = config.icon;
      return (
        <span key={tag} className={`inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full border ${config.style}`}>
          <Icon className="w-3 h-3" />
          {config.label}
        </span>
      );
    }
    return (
      <span key={tag} className="inline-flex items-center text-[11px] font-medium px-2 py-0.5 rounded-full border bg-slate-50 text-slate-600 border-slate-200">
        {tag.replace(/_/g, ' ')}
      </span>
    );
  });

  return <div className="flex flex-wrap gap-1.5">{chips}</div>;
}

export function DistanceMeta({ homeMiles, baseMiles, isRemote }) {
  const parts = [];
  if (isRemote) {
    parts.push(<span key="remote" className="text-emerald-600 font-medium">Remote</span>);
  }
  if (homeMiles != null) {
    parts.push(<span key="home" className="text-slate-500">{Math.round(homeMiles)} mi from home</span>);
  }
  if (baseMiles != null) {
    parts.push(<span key="base" className="text-slate-500">{Math.round(baseMiles)} mi from base</span>);
  }
  if (!parts.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs">
      {parts.map((p, i) => (
        <span key={i} className="flex items-center gap-1">
          {i === 0 ? null : <span className="text-slate-300">|</span>}
          {p}
        </span>
      ))}
    </div>
  );
}
